import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import '../../../../App.css';
import { styled } from '../../../../components/styled';
import SpText from '../../../../components/atoms/SpText';
import SpButton from '../../../../components/atoms/SpButton';
import SpTextInput from '../../../../components/atoms/SpTextInput';
import { ArrowBack } from '@material-ui/icons';
import moment from 'moment';
import { Button as MuiButton, FormControlLabel, Grid, Radio } from '@material-ui/core';
import { withSnackbar } from '../../../../components/atoms/SpSnackBar';
import { theme, theme as themeStyle } from '../../../../components/theme';
import { createBike, findBikeById, updateBike } from '../../../../models/actions/Bikes';
import { findStationById, publishMess } from '../../../../models/actions/Stations';
import { UserSessionContext } from '../../../../App';
import SpDialog from '../../../../components/atoms/SpDialog';

const CustomRadioButton = styled(Radio)({
  color: themeStyle.colors.mainGreen.secondary
});

const TitleToolbarSection = styled('div')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start'
});

const AdminStationBikesDetails = (props) => {
  const [currentBike, setCurrentBike] = useState();
  const [currentStation, setCurrentStation] = useState('');
  const [streetAssistanceQuant, setStreetAssistanceQuant] = useState();
  const [assistanceQuant, setAssistanceQuant] = useState();
  const [supportDialogLock, setSupportDialogLock] = useState(false);

  const { stationId, bikeId } = useParams();
  const history = useHistory();
  const { authData, setAuthData } = useContext(UserSessionContext);

  const { register, control, error, getValues, setValue, handleSubmit, reset } = useForm({
    shouldUnregister: false,
    name: 'station'
  });

  const fetchData = async () => {
    try {
      if (bikeId) {
        const response = await findBikeById({ id_bike: bikeId }, authData.accessToken);
        if (response) {
          reset({ ...response });
          setCurrentBike(response);
        }
      }
      const responseStation = await findStationById({ id_station: stationId }, authData.accessToken);
      responseStation && setCurrentStation(responseStation);
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const saveStation = async () => {
    try {
      props.isLoading(true);
      if (bikeId) {
        const response = await updateBike({ bike: { ...getValues() } }, authData.accessToken);
        if (response) {
          setCurrentBike(response);
          props.snackbarShowMessage(response.message);
        }
      } else {
        const response = await createBike({ bike: { ...getValues(), id_station: stationId } }, authData.accessToken);
        response && history.push(`/admin/stations/edit/${stationId}/ebikes`);
      }
      props.isLoading(false);
    } catch (error) {
      props.isLoading(false);
      props.snackbarShowErrorMessage(error);
    }
  };

  const handleSupportUnlock = async () => {
    try {
      setSupportDialogLock(!supportDialogLock);
      props.isLoading(true);
      await publishMess({ station: { mac_address: currentStation?.mac_address }, action: { payload: currentBike?.station_position >= 10 ? `${currentBike?.station_position}` : `0${currentBike?.station_position}`, type: 'unlock' } }, authData.accessToken);
      props.isLoading(false);
      props.snackbarShowMessage('Bici sbloccata con successo!');
    } catch (error) {
      props.isLoading(false);
      props.snackbarShowErrorMessage('Errore durante sblocco bici');
    }
  };

  const formControlStyleInput = { width: '100%', marginTop: '1%' };

  return (
    <>
      <Grid
        style={{ paddingLeft: '1%' }}
        direction="column"
        container
        spacing={2}
      >
        <Grid
          item
          container
          xs={12}
          spacing={1}
          justifyContent="flex-end"
        >
          <Grid
            item
            xs={'auto'}
          >
            <SpButton
              buttonType="accept"
              text={'Ebike'}
              style={{ maxWidth: '40%', backgroundColor: theme.colors.mainGreen.secondary, color: 'white' }}
              ariant="h1PageTitle"
              onClick={() => history.push({ pathname: `/admin/stations/edit/${stationId}/ebikes` })}
            />
          </Grid>
          {/* <Grid
            item
            xs={'auto'}
          >
            <SpButton
              buttonType="accept"
              text={'Noleggi'}
              style={{ maxWidth: '40%' }}
              ariant="h1PageTitle"
              onClick={() => history.push(`/admin/stations/edit/${stationId}/rents`)}
            />
          </Grid>
          <Grid
            item
            xs={'auto'}
          >
            <SpButton
              buttonType="accept"
              text={'Prenotazioni'}
              style={{ maxWidth: '40%' }}
              ariant="h1PageTitle"
              onClick={() => history.push(`/admin/stations/edit/${stationId}/reservations`)}
            />
          </Grid>
          <Grid
            item
            xs={'auto'}
          >
            <SpButton
              buttonType="accept"
              text={'Segnalazioni'}
              style={{ maxWidth: '40%' }}
              ariant="h1PageTitle"
              onClick={() => history.push(`/admin/stations/edit/${stationId}/reports`)}
            />
          </Grid> */}
        </Grid>

        <Grid
          item
          container
          xs={12}
          justifyContent="space-between"
        >
          <Grid
            item
            xs={8}
          >
            <TitleToolbarSection>
              <ArrowBack
                onClick={() => history.push(`/admin/stations/edit/${stationId}/ebikes`)}
                style={{ width: 25, color: themeStyle.colors.mainGreen.secondary, height: 50, cursor: 'pointer' }}
              />
              <SpText
                variant="breadcrumbs"
                style={{ marginRight: '5px' }}
              >
                {bikeId ? `Home / Stazione / ${currentStation?.name} / Ebike / ` : `Home / Stazione / ${currentStation?.name} / Ebike `}
              </SpText>
              <SpText variant="breadcrumbsSelected">{currentBike?.code}</SpText>
            </TitleToolbarSection>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={3}
          direction="column"
          style={{ backgroundColor: 'rgb(77, 172, 39,0.7)', paddingBottom: 30 }}
        >
          <Grid
            item
            xs={12}
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            {bikeId ? (
              <>
                <Grid
                  item
                  xs={'auto'}
                >
                  <SpButton
                    buttonType="accept"
                    text={'Modifica'}
                    style={{ width: '30%' }}
                    variant="h1PageTitle"
                    onClick={handleSubmit(saveStation)}
                  />
                </Grid>
                <Grid
                  item
                  xs={'auto'}
                >
                  <SpButton
                    buttonType="accept"
                    text={'Sblocco Assistenza'}
                    style={{ maxWidth: '30%', color: 'red', fontSize: '13px' }}
                    variant="h1PageTitle"
                    onClick={() => setSupportDialogLock(!supportDialogLock)}
                  />
                </Grid>
              </>
            ) : (
              <Grid
                item
                xs={3}
              >
                <SpButton
                  buttonType="accept"
                  text={'Salva'}
                  style={{ width: '100%' }}
                  ariant="h1PageTitle"
                  onClick={handleSubmit(saveStation)}
                />
              </Grid>
            )}
          </Grid>
          <Grid
            item
            xs={12}
          >
            <form>
              <SpTextInput
                label="Codice"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="code"
              />
              <SpTextInput
                label="Misura"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="size"
              />
              <SpTextInput
                label="Lotto di costruzione"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="lotto"
              />
              <SpTextInput
                label="Posizione sulla stazione"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="station_position"
              />
              {bikeId && (
                <SpTextInput
                  label="Chiamate in assistenza per questa bici"
                  value={assistanceQuant}
                  labelColor={'black'}
                  type="string"
                  disabled={true}
                  formControlStyle={formControlStyleInput}
                  variant="inputLabel"
                />
              )}
              <SpTextInput
                label="Gestione locale assistenza"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="local_assistance"
              />
              <SpTextInput
                label="Garanzia difetti meccanici/elettronici"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="warranty_length"
              />
              {bikeId && (
                <SpTextInput
                  label="Chiamate in assistenza per assistenza stradale/app"
                  value={streetAssistanceQuant}
                  labelColor={'black'}
                  disabled={true}
                  type="string"
                  formControlStyle={formControlStyleInput}
                  variant="inputLabel"
                />
              )}
            </form>
          </Grid>
        </Grid>
      </Grid>
      <SpDialog
        style={{ padding: '1%' }}
        open={supportDialogLock}
        setOpen={() => setSupportDialogLock(!supportDialogLock)}
        title={'Sblocca per assistenza'}
      >
        <Grid
          container
          direction="column"
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <SpText variant="text">{'Sei sicuro di voler sbloccare la bici? Assicurati di essere sul pusto in quanto questo è uno sblocco di emergenza.'}</SpText>
          </Grid>
          <Grid
            item
            container
            xs={12}
            alignItems={'flex-start'}
          >
            <Grid
              item
              xs={4}
            >
              <SpButton
                text={'CONFERMA'}
                buttonType="accept"
                onClick={() => handleSupportUnlock()}
              />
            </Grid>
            <Grid
              item
              xs={4}
              style={{ marginBottom: '1%' }}
            >
              <SpButton
                text={'ANNULLA'}
                buttonType="accept"
                onClick={() => {
                  setSupportDialogLock(!supportDialogLock);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </SpDialog>
    </>
  );
};

export default withSnackbar(AdminStationBikesDetails);
